"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importGlob = void 0;
const tslib_1 = require("tslib");
/**
 * @example
 * await importGlob(
 *    import.meta.glob('./components/base/*.vue'),
 *    import.meta.glob('./components/custom/*.vue')
 * )
 *
 * @param globs - import.meta.glob
 */
const importGlob = (...globs) => {
    return new Promise((resolve) => {
        const loop = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _a;
            let i = 0;
            const imports = [];
            for (const modules of globs) {
                for (const pathName in modules) {
                    const module = yield modules[pathName]();
                    const fileName = ((_a = pathName
                        .replace(/^\.\/(.*)\.\w+$/, '$1')
                        .split('/')
                        .pop()) === null || _a === void 0 ? void 0 : _a.split('.').shift()) || `name${i}`;
                    imports.push({
                        path: pathName,
                        name: fileName,
                        module: module,
                    });
                    i += 1;
                }
            }
            resolve(imports);
        });
        loop();
    });
};
exports.importGlob = importGlob;
